<login-container titel="Ændre kodeord..." [arbejder]="arbejder">
  <form [formGroup]="form" (ngSubmit)="glemtKodeordClick()">
    <div>
      <div>Indtast ønskede adgangskode</div>
      <div>
        <mat-form-field fxLayout="column">
          <input matInput placeholder="Adgangskode" formControlName="nytKodeord" type="password" id="nytKodeord" required />
          @if (
            (!form.controls.nytKodeord.hasError('minLength') || !form.controls.nytKodeord.hasError('maxLength')) &&
            !form.controls.nytKodeord.hasError('required')
            ) {
            <mat-error
              >
              Kodeord skal være 4-24 tegn.
            </mat-error>
          }
          @if (form.controls.nytKodeord.hasError('required')) {
            <mat-error> Et kodeord er krævet. </mat-error>
          }
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column">
          <input
            matInput
            placeholder="Gentag adgangskode"
            formControlName="gentagNytKodeord"
            type="password"
            id="gentagNytKodeord"
            required
            />
            @if (form.controls.gentagNytKodeord.hasError('invalid') && !form.controls.gentagNytKodeord.hasError('required')) {
              <mat-error
                >
                De to kodeord stemmer ikke overens.
              </mat-error>
            }
            @if (form.controls.gentagNytKodeord.hasError('required')) {
              <mat-error> Et kodeord er krævet. </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div fxLayoutAlign="end start">
        <button type="submit" mat-flat-button class="backgroundcolor2" id="login">Gem kodeord</button>
      </div>
    </form>
  </login-container>
